import { Text, chakra } from "@chakra-ui/react";

export const TextComponent = chakra(Text, {
  base: {
    color: "fgSecondary",
  },
});
